import React, { useState } from "react";
import { Box, Card, Select, ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import FormatPaintIcon from "@material-ui/icons/FormatPaint";
import EuroSymbolIcon from "@material-ui/icons/EuroSymbol";

import i18n from "i18next";

const valueToIconMap = (variantProp) => {
  const greyDeactivated = "#aaa";
  const blueActivated = "#64acbe"; // Work well if it matches the color for Zone 7
  const bluePaintBrushIcon = (
    <ListItemIcon style={{ color: blueActivated }}>
      <FormatPaintIcon />
    </ListItemIcon>
  );

  let table = {
    none: {
      icon: (
        <ListItemIcon style={{ color: greyDeactivated }}>
          <EuroSymbolIcon />
        </ListItemIcon>
      ),
      text: i18n.t("climateAnalyticsSelects.noKpi"),
    },

    policyNumber: {
      icon: bluePaintBrushIcon,
      text: i18n.t("climateAnalyticsSelects.policyNumber"),
    },

    postrenewalValueFinal: {
      icon: bluePaintBrushIcon,
      text: i18n.t("climateAnalyticsSelects.postrenewalValueFinal"),
    },
  };

  if (variantProp !== "AgroClimateAnalytics") {
    // Note, it can be null
    table = {
      ...table,
      accruedRisk: {
        icon: bluePaintBrushIcon,
        text: i18n.t("climateAnalyticsSelects.accruedRisk"),
      },
    };
  } else {
    table = {
      ...table,
      premiumNettoEur: {
        icon: bluePaintBrushIcon,
        text: i18n.t("climateAnalyticsSelects.premiumNettoEur"),
      },
    };
  }

  return table;
};

export const getValueToIconMapForKPI = (selectedValue, variantProp) => {
  return valueToIconMap(variantProp)[selectedValue];
};

export const KpiSelectorTool = (kpiSelect, setKpiSelect, variantProp) => {
  const menuStyle = {
    position: "absolute",
    top: 300,
    left: 0,
    padding: "10px",
  };
  const [openSelect, setOpenSelect] = useState(false);

  const renderGivenValueKpi = (selectedValue) => {
    const iconText = getValueToIconMapForKPI(selectedValue, variantProp);
    return (
      <Box
        sx={{
          flexDirection: "row",
          display: "flex",
        }}
      >
        {iconText.icon}
        <ListItemText primary={iconText.text} />
      </Box>
    );
  };

  const createMenuItem = (key, value) => {
    return (
      <MenuItem key={key} value={key}>
        {value.icon}
        <ListItemText primary={value.text}></ListItemText>
      </MenuItem>
    );
  };

  const createAllMenuItems = () => {
    const allItems = Object.entries(valueToIconMap(variantProp)).map(([key, value]) =>
      createMenuItem(key, value),
    );
    return allItems;
  };

  return (
    <Box style={menuStyle}>
      <Card>
        <Select
          value={kpiSelect}
          open={openSelect}
          onClose={() => setOpenSelect(false)}
          onOpen={() => setOpenSelect(true)}
          onChange={(e) => {
            setKpiSelect(e.target.value);
          }}
          renderValue={(value) => renderGivenValueKpi(value)}
        >
          {createAllMenuItems()}
        </Select>
      </Card>
    </Box>
  );
};
